import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { useNewChat } from '@matrix-forge/ui/hooks/useNewChat';
import type { ClientTool } from '@matrix-forge/ui/hooks/useClientTools';

/** Wraps useNewChat with a callback that navigates to the route for the newly created chat. */
export const useNewChatAndNavigate = (extraClientTools?: ClientTool[]) => {
  const navigate = useNavigate();
  const onNewChat = useCallback(
    ({ conversationId, agentId }: { conversationId: string; agentId: string }) => {
      navigate(`/persona/${agentId}/conversation/${conversationId}`, { replace: true });
    },
    [navigate]
  );
  return useNewChat({ onNewChat, extraClientTools });
};
